enum Direction {
    North,
    South,
    East,
    West
}

export default Direction